module.exports = "span {\n  cursor: pointer;\n  color: #8fbdff; }\n\nspan:hover {\n  opacity: 0.8; }\n"